import {Calendar} from 'vanilla-calendar-pro';


document.addEventListener('DOMContentLoaded', () => {
    // const customDatesPopup = document.getElementById('customDatesPopup');
    // const customDatesPopupCloseButton = document.getElementById('customDatesPopupClose');
    // const customDatesPopUpTriggers = document.querySelectorAll('.js-custom-dates-popup-trigger');
    //
    // const customDatesWrapper = document.querySelector('.custom-dates-wrapper');
    //
    // const checkInButton = customDatesPopup.querySelector('#customDatesFrom');
    // const checkOutButton = customDatesPopup.querySelector('#customDatesTo');
    //
    // customDatesPopUpTriggers.forEach(trigger =>{
    //     trigger.addEventListener('click', ()=>{
    //         customDatesPopup.classList.remove('hidden');
    //         document.documentElement.classList.add('no-scroll');
    //
    //     });
    //
    // });
    //
    // customDatesPopupCloseButton.addEventListener('click', ()=>{
    //     customDatesPopup.classList.add('hidden')
    //     document.documentElement.classList.remove('no-scroll');
    // })
    //
    // if (!customDatesPopup) return;
    //
    // const dateFrom = document.querySelector('input[name="date-from"]');
    // const dateTo = document.querySelector('input[name="date-to"]');
    // dateFrom.setAttribute('readonly', 'true');
    // dateTo.setAttribute('readonly', 'true');
    //
    //
    //
    //
    // const calendar = new Calendar('#customDates', {
    //     selectedTheme: 'light',
    //     type: 'multiple',
    //     displayMonthsCount: 2,
    //     monthsToSwitch: 1,
    //     selectionDatesMode: 'multiple-ranged',
    //     displayDatesOutside: false,
    //     // positionToInput: 'left',
    //     positionToInput: ['bottom', 'center'],
    //     dateMin: 'today',
    //     // inputMode: true,
    //     styles: {
    //         arrowPrev: 'arrow-prev',
    //         arrowNext: 'arrow-next'
    //     },
    //
    //     onClickDate: (self, event) => {
    //         handleDateClick(self, event);
    //     }
    // });
    // function handleDateClick(self, event) {
    //     // console.log(self);
    //     updateButtonDates(self.context.selectedDates,dateFrom, dateTo)
    //     // resetDisabledDays()
    //
    //
    //     if (self.context.selectedDates[0] && !self.context.selectedDates[1]) {
    //         const currentDay = new Date(self.context.selectedDates[0])
    //         // createDisabledDates(currentDay)
    //     }
    //
    //     if (self.context.selectedDates[0] && self.context.selectedDates[1]) {
    //         customDatesWrapper.classList.remove('dates-error');
    //     }
    //
    //     // if (self.context.selectedDates[0] && self.context.selectedDates[1]){
    // }
    //
    // function updateButtonDates(datesArray, buttonFrom, buttonTo) {
    //     if (datesArray[0]) {
    //         // checkInButtonText.innerText = datesArray[0];
    //         checkInButton.innerText = datesArray[0];
    //         dateFrom.value = datesArray[0];
    //     } else {
    //         dateFrom.value = '';
    //         checkInButton.innerText = "Check in";
    //     }
    //
    //     if (datesArray[1]) {
    //         checkOutButton.innerText = datesArray[1];
    //         dateTo.value = datesArray[1];
    //     } else {
    //         dateTo.value = '';
    //         // checkOutButtonText.innerText = 'Check out'
    //         checkOutButton.innerText = 'Check out';
    //     }
    // }
    //
    // calendar.init();
    //
    //
    // const wpcf7Elm = customDatesPopup.querySelector( '.wpcf7' );
    //
    // wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
    //     console.log('dateFrom ', dateFrom.value);
    //     console.log('dateTo ', dateTo.value);
    //
    //     if (
    //         dateFrom.value == '' ||
    //         dateFrom.value == null ||
    //         dateTo.value == '' ||
    //         dateTo.value == null
    //     ) {
    //         customDatesWrapper.classList.add('dates-error');
    //     }else{
    //         customDatesWrapper.classList.remove('dates-error');
    //     }
    //
    // }, false );


    initCustomPopup('customDatesPopup', '.js-custom-dates-popup-trigger', '#customDates')
    initCustomPopup('customSeasonPopup', '.js-custom-season-popup-trigger', '#calendarAcademicYear')

})



function initCustomPopup(popupID, popupTriggerClass, calendarID){
    const popup = document.getElementById(popupID);

    if (!popup){
        return;
    }

    const popupCloseButton = popup.querySelector('.js-custom-season-popup-close');

    const customPopUpTriggers = document.querySelectorAll(popupTriggerClass);

    const customDatesWrapper = document.querySelector('.custom-dates-wrapper');

    const checkInButton = popup.querySelector('[data-from]');
    const checkOutButton = popup.querySelector('[data-to]');

    customPopUpTriggers.forEach(trigger =>{
        trigger.addEventListener('click', ()=>{
            popup.classList.remove('hidden');
            document.documentElement.classList.add('no-scroll');

        });

    });

    popupCloseButton.addEventListener('click', ()=>{
        popup.classList.add('hidden')
        document.documentElement.classList.remove('no-scroll');
    })


    const dateFrom = document.querySelector('input[name="date-from"]');
    const dateTo = document.querySelector('input[name="date-to"]');
    dateFrom.setAttribute('readonly', 'true');
    dateTo.setAttribute('readonly', 'true');



    const calendar = new Calendar(calendarID, {
        selectedTheme: 'light',
        type: 'multiple',
        displayMonthsCount: 2,
        monthsToSwitch: 1,
        selectionDatesMode: 'multiple-ranged',
        displayDatesOutside: false,
        // positionToInput: 'left',
        positionToInput: ['bottom', 'center'],
        dateMin: 'today',
        // inputMode: true,
        styles: {
            arrowPrev: 'arrow-prev',
            arrowNext: 'arrow-next'
        },

        onClickDate: (self, event) => {
            handleDateClick(self, event);
        }
    });
    function handleDateClick(self, event) {
        // console.log(self);
        updateButtonDates(self.context.selectedDates,dateFrom, dateTo)
        // resetDisabledDays()


        if (self.context.selectedDates[0] && !self.context.selectedDates[1]) {
            const currentDay = new Date(self.context.selectedDates[0])
            // createDisabledDates(currentDay)
        }

        if (self.context.selectedDates[0] && self.context.selectedDates[1]) {
            customDatesWrapper.classList.remove('dates-error');
        }

        // if (self.context.selectedDates[0] && self.context.selectedDates[1]){
    }

    function updateButtonDates(datesArray, buttonFrom, buttonTo) {
        if (datesArray[0]) {
            // checkInButtonText.innerText = datesArray[0];
            checkInButton.innerText = datesArray[0];
            dateFrom.value = datesArray[0];
        } else {
            dateFrom.value = '';
            checkInButton.innerText = "Check in";
        }

        if (datesArray[1]) {
            checkOutButton.innerText = datesArray[1];
            dateTo.value = datesArray[1];
        } else {
            dateTo.value = '';
            // checkOutButtonText.innerText = 'Check out'
            checkOutButton.innerText = 'Check out';
        }
    }


    calendar.init();



    const wpcf7Elm = popup.querySelector( '.wpcf7' );

    wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
        console.log('dateFrom ', dateFrom.value);
        console.log('dateTo ', dateTo.value);

        if (
            dateFrom.value == '' ||
            dateFrom.value == null ||
            dateTo.value == '' ||
            dateTo.value == null
        ) {
            customDatesWrapper.classList.add('dates-error');
        }else{
            customDatesWrapper.classList.remove('dates-error');
        }

    }, false );
}